import constants from '../constants';
import getIconDialogCommonTraits from '../helpers/get-icon-dialog-common-traits';
import trackEvent from './track-event';

const { events } = constants;

export default function trackSelectIconSearchPerformed({
  dialogId,
  targetElementId,
  searchTerm,
  searchResults,
  tabId,
  premiumAvailable,
}) {
  const traits = {
    dialogId,
    searchTerm,
    searchResults,
    tabId,
    premiumAvailable,
    ...getIconDialogCommonTraits(targetElementId),
  };

  trackEvent(events.SELECT_ICON_SEARCH_PERFORMED, traits);
}
